// ============================================================================
// BootstrapPasswordBanner
// ----------------------------------------------------------------------------
// Shown when the current session was opened with the INSTALL-TIME bootstrap
// password (backend login response flags usingBootstrapPassword; LoginPage
// persists it across its hard-reload via sessionStorage.qm_bootstrap_pw_login).
// The install password is a shared bootstrap secret, not a personal
// credential — this strip says so plainly and routes to the existing
// Settings → Account → Change password flow. Dismiss lasts for the session.
// ============================================================================

import React from 'react';
import { Icons } from './Icon';

interface BootstrapPasswordBannerProps {
    /** Opens the settings surface on the account scope. */
    onOpenSettings: () => void;
    /** Hides the banner for the rest of this session. */
    onDismiss: () => void;
}

export function BootstrapPasswordBanner({ onOpenSettings, onDismiss }: BootstrapPasswordBannerProps) {
    return (
        <div role="status" style={{
            background: 'linear-gradient(90deg, #fffbeb 0%, #fef3c7 50%, #fffbeb 100%)',
            borderBottom: '2px solid #d97706',
            padding: '7px 16px',
            display: 'flex', alignItems: 'center', gap: '10px',
            flexShrink: 0, zIndex: 41,
        }}>
            <div style={{ width: '24px', height: '24px', borderRadius: '50%', background: 'rgba(217,119,6,0.16)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <Icons.Key size={13} style={{ color: '#92400e' }} />
            </div>
            <div style={{ flex: 1, minWidth: 0, fontSize: '13px', color: '#78350f' }}>
                <strong>You signed in with the install password.</strong>{' '}
                It is a shared bootstrap credential — set your own to make this account yours.
            </div>
            <button
                type="button"
                className="qm-inline-action-btn"
                onClick={onOpenSettings}
                style={{ border: '1px solid #d97706', background: '#fff', color: '#92400e', borderRadius: 6, padding: '3px 12px', fontSize: '12.5px', cursor: 'pointer', flexShrink: 0 }}
            >
                Set my password
            </button>
            <button
                type="button"
                aria-label="Dismiss for this session"
                onClick={onDismiss}
                style={{ border: 'none', background: 'transparent', color: '#92400e', fontSize: '16px', cursor: 'pointer', padding: '0 4px', flexShrink: 0, lineHeight: 1 }}
            >
                ×
            </button>
        </div>
    );
}
